function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Entry, EntryPart, QueryBehaviorEntry, SelectorTypeDefinitions } from 'common/query-builder/query-entry-section/types';
import { Segmentation } from 'common/types/reports/query';
import { PropertyFilter } from 'common/widgets/property-filter-menu/models/property-filter';
// eslint-disable-next-line import/no-cycle
import { FilterParts } from 'common/query-builder/query-entry-section/row-types/filter/parts';
import { BehaviorRowDateRange } from 'common/query-builder/query-entry-section/components/behaviors';
import { EntryRowProps } from 'common/query-builder/query-entry-section/row-types/types';
import { SelectTheme } from 'common/components/select/constants';
import { SelectReact } from 'common/components/select';
import { isTimeSeriesChartType } from 'common/report/insights/visualization/charts/chart-display/utils';
import { BehavioralSubItem, BehavioralTimeReference, PropertySelectorProps } from '../template';
import styles from './index.module.styl';
export function AggregateUserFrequencyByGroupSubItem(props: PropertySelectorProps & {
  contextPanelParentElement: HTMLElement | HTMLDivElement;
  isFilter: boolean;
  extraFilters?: React.ReactNode;
}) {
  var _behavior$event;
  const {
    t
  } = useTranslation();
  const selected = props.selected as Segmentation;
  const behavior = selected.behavior!;
  const filter = behavior.filters[0];
  return <div className={clsx({
    [styles.containerSidebar]: props.hasNewUI,
    [styles.containerCohorts]: !props.hasNewUI
  })} data-sentry-component="AggregateUserFrequencyByGroupSubItem" data-sentry-source-file="index.tsx">
      <BehavioralSubItem {...props} showBehaviorTimeReference={false} selected={filter} onSelect={f => {
      props.onSelect(_objectSpread(_objectSpread({}, selected), {}, {
        behavior: _objectSpread(_objectSpread({}, behavior), {}, {
          filters: [f]
        })
      }));
      const nextPart = props.isFilter ? EntryPart.FilterValue : EntryPart.NestedBehaviorFilterValue;
      props.setActivePart(nextPart, "open");
    }} data-sentry-element="BehavioralSubItem" data-sentry-source-file="index.tsx" />

      <div className={clsx({
      [styles.filtersSidebar]: props.hasNewUI,
      [styles.filtersCohort]: !props.hasNewUI
    })}>
        <div className={styles.filterPart}>
          {!props.hasNewUI && <SelectReact elref='eventPlaceHolder' disableSearch menuWidth={200} menuHeight={0} readonly={false} selectedOption={"Total Events"} theme={SelectTheme.Select} neverShowCaret disableTooltip sections={[{
          items: [{
            label: "Total Events",
            isSelected: true
          }]
        }]} onChange={() => {
          return;
        }} />}
          <FilterParts filter={new PropertyFilter(filter)} hideListQuantifier hasNewUI={props.hasNewUI} readonly={false} unit={props.hasNewUI ? "Times" : undefined} eventNames={[(_behavior$event = behavior.event) === null || _behavior$event === void 0 ? void 0 : _behavior$event.value]} projectId={props.sectionProps.projectId!} workspaceId={props.sectionProps.workspaceId!} userId={props.sectionProps.userId!} dataGroupId={props.sectionProps.dataGroupId!} updateEntry={filterValue => {
          props.onSelect(_objectSpread(_objectSpread({}, selected), {}, {
            behavior: _objectSpread(_objectSpread({}, selected.behavior), {}, {
              filters: [filterValue.getAttributes()]
            })
          }));
        }} setActiveEntry={state => props.setActivePart(EntryPart.NestedBehaviorFilterValue, state)} isValueActive={props.activePart === EntryPart.NestedBehaviorFilterValue} hideEvents data-sentry-element="FilterParts" data-sentry-source-file="index.tsx" />
          {!props.hasNewUI && <div className={styles.dateSelector}>
              <BehaviorRowDateRange {...props as EntryRowProps<QueryBehaviorEntry>} contextPanelParentElement={props.contextPanelParentElement} entry={{
            type: SelectorTypeDefinitions.Behavior,
            event: {
              value: null,
              label: ""
            },
            dateRange: behavior.dateRange,
            aggregationOperator: behavior.aggregationOperator,
            filtersOperator: behavior.filtersOperator
          }} updateEntry={(action, qbe: Entry | undefined, _options) => {
            qbe = qbe as QueryBehaviorEntry;
            behavior.dateRange = qbe.dateRange;
            behavior.filters[0].behavior!.dateRange = qbe.dateRange;
            return props.updateEntry(action, props.entry);
          }} />
            </div>}
        </div>
        <div className={styles.filterPart}>
          {!props.hasNewUI && <SelectReact elref='eventPlaceHolder' disableSearch menuWidth={200} menuHeight={0} readonly={false} selectedOption={"Total Users"} theme={SelectTheme.Select} neverShowCaret disableTooltip sections={[{
          items: [{
            label: "Total Users",
            isSelected: true
          }]
        }]} onChange={() => {
          return;
        }} />}
          {props.extraFilters}
        </div>
      </div>
      {props.hasNewUI && isTimeSeriesChartType(props.currentChartType) && <BehavioralTimeReference {...props} selected={props.selected} onSelect={props.onSelect} activePart={props.activePart} setActivePart={props.setActivePart} currentProject={props.currentProject} tooltip={{
      text: t("query-builder.behavior-interval.number-users-who-did-tooltop")
    }} />}
    </div>;
}